/**
 * @ngdoc directive
 * @name header
 *
 * @description
 * Page header
 */
module.directive('headeravenir', ['scrolllocker', '$timeout', '$window', '$document', '$state', '$location',
        function (scrolllocker, $timeout, $window, $document, $state, $location) {
    'use strict';
    return {
        restrict: 'E',
        controller: ['$scope', '$rootScope', function ($scope, $rootScope) {

            $scope.logo = {
                text: 'Glénans Avenir',
                state: 'homepage'
            };
            $scope.buttonMenu = 'Ouvrir le menu';
            $scope.isMenuOpen = false;

            /* switch menu visibility */
            $scope.toggleMenu = function () {
                if ($scope.isMenuOpen) {
                    $scope.isMenuOpen = false;
                    scrolllocker.unlock();
                } else {
                    $scope.isMenuOpen = true;
                    scrolllocker.lock();
                }
            };

            /* prevent permanent menu display */
            $scope.clickMenu = function () {
                $scope.isMenuOpen = false;
                scrolllocker.unlock();
            };

            $scope.menuHeader = [];
            $scope.config = $rootScope.config;

            $scope.menuDonation = {
                title: 'Faire un don',
                url: $state.href('donation'),
                top: 0,
                left: 0
            };
            $scope.isStickyHidden = false;
            $scope.stickyDonation = $scope.menuDonation;

            $scope.isCurrent = function (path) {
                return $location.path().substr(0, path.length) === path;
            };

            $rootScope.$on('stickyHide', function () {
                $scope.isStickyHidden = true;
            });
            $rootScope.$on('stickyShow', function () {
                $scope.isStickyHidden = false;
            });

        }],
        link: function ($scope, element) {
            /* test if donation panel is visible */
            var isDonationPanelVisible = function () {
                var elDonation = document.getElementsByClassName('aqua-donation')[0];
                var donationCoordinate;
                if (!elDonation) {
                    return false;
                }
                donationCoordinate = elDonation.getBoundingClientRect();
                return (
                    (donationCoordinate.top >= 0 && donationCoordinate.top <= ($window.innerHeight || $document[0].documentElement.clientHeight)) ||
                    (donationCoordinate.bottom >= 0 && donationCoordinate.bottom <= ($window.innerHeight || $document[0].documentElement.clientHeight))
                );
            };

            /* sticky handler */
            var setButtonPosition = function () {
                var button = element[0].querySelector('.aqua-header--nav-item > .aqua-header--nav-link-filled');
                // hide button whenever donation panel is visible
                var hidden = isDonationPanelVisible();

                if (!button) {
                    $scope.isStickyHidden = true;
                    return;
                }
                if (hidden) {
                    $scope.hasSafePosition = false;
                    return;
                }
                
                var position = button.getBoundingClientRect();
                if (position.top > 10) {
                    $scope.stickyDonation.top = position.top + 'px';
                } else {
                    $scope.stickyDonation.top = '10px';
                }
                $scope.stickyDonation.left = position.left + 'px';
                $scope.hasSafePosition = true;
            };

            var initStickyButton = function () {
                // set position
                $timeout(function () {
                    // get navigation button position
                    $scope.$apply(function () {
                        setButtonPosition();
                    });
                }, 500);

                $window.onresize = function () {
                    $scope.$apply(function () {
                        setButtonPosition();
                    });
                };
                $window.onscroll = function () {
                    $scope.$apply(function () {
                        setButtonPosition();
                    });
                };

                $scope.$on('$destroy', function () {
                    // remove element
                    $window.onresize = null;
                    $window.onscroll = null;
                });
            };
            initStickyButton();
        },
        template:
                '<div class="aqua-header" ng-class="{\'is-open\': isMenuOpen}">' +
                '  <div class="aqua-header--container grid-main grid">' +
                /* logo */
                '    <div class="grid-12-m grid-10-s grid-center-nl"><a ng-if="logo" ui-sref="{{logo.state}}" ng-click="clickMenu()" class="aqua-header--logo"><span class="is-sr-only">{{logo.text}}</span></a></div>' +
                /* button menu (for small resolution only) */
                '    <div class="is-hidden-ns grid-2 grid grid-middle grid-right"><button class="aqua-header--button" ng-click="toggleMenu()"><span class="is-sr-only">{{buttonMenu}}</span></button></div>' +
                /* navigation list */
                '    <nav class="aqua-header--nav grid grid-12-m grid-center-m grid grid-middle grid-right" ng-click="clickMenu()">' +
                '      <ul class="grid grid-middle grid-gutter-small">' +
                '        <li ng-if="config.site" class="aqua-header--nav-item grid-12-s" ng-repeat="link in config.site.header_menu">' +
                '          <a ng-href="{{link.url}}" ng-class="{\'is-active\': isCurrent(link.url), \'aqua-header--nav-link-filled\': link.filled, \'aqua-header--nav-link\': !link.filled, \'is-invisible\': link.filled && !isStickyHidden}">{{link.title}}</a>' +
                '        </li>' +
                '        <li class="aqua-header--nav-item grid-12-s">' +
                '          <a ng-href="{{menuDonation.url}}" class="aqua-header--nav-link-filled" ng-class="{\'is-active\': isCurrent(menuDonation.url), \'is-invisible\': menuDonation.filled && !isStickyHidden}">{{menuDonation.title}}</a>' +
                '        </li>' +
                '      </ul>' +
                '    </nav>' +
                '  </div>' +
                '  <div ng-if="stickyDonation" class="aqua-header--sticky" ng-class="{\'is-hidden\': isStickyHidden === true || !hasSafePosition}" ng-style="{top:stickyDonation.top, left: stickyDonation.left}"><a class="aqua-header--nav-link-filled" ng-href="{{stickyDonation.url}}">{{stickyDonation.title}}</a></div>' +
                '</div>'
    };
}]);
